import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import { EditorModule } from '@/store/modules/editor'
  import useEditor from '@/composables/useEditor'
  import { UserModule } from '@/store/modules/user'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditorButtons',
  props: {
    path: String,
    hideSaveDiscardButtons: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { undoIcon, checkmark, closeIcon } = useIcons()
  const { hasChanges, saveAllChanges, discardAllChanges } = useEditor(route)

  const canUndo = computed(() => EditorModule.canUndo(props.path || route.path))
  const canRedo = computed(() => EditorModule.canRedo(props.path || route.path))

  const onUndoClick = () => {
    EditorModule.undo(props.path || route.path)
  }
  const onRedoClick = () => {
    EditorModule.redo(props.path || route.path)
  }

  const hasEditButtons = computed(() => {
    return EditorModule.editMode && hasChanges.value
  })

  const showingAdminNav = computed(() => {
    return UserModule.isCompanyAdmin && !route.meta?.hideAdminNav
  })

  const editorButtonsTopPadding = computed(() =>
    showingAdminNav.value ? `${120 + UserModule.bannersTotalHeightValue}px` : '0px',
  )

return { __sfc: true,props, route, undoIcon, checkmark, closeIcon, hasChanges, saveAllChanges, discardAllChanges, canUndo, canRedo, onUndoClick, onRedoClick, hasEditButtons, showingAdminNav, editorButtonsTopPadding, computed, KetchUpButton, useIcons, SVGRenderer, EditorModule, useEditor, UserModule, useRoute }
}

})